import { useHistory, useLocation } from 'react-router-dom';

const useSearchParams = () => {
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const setSearchParam = (key: string, value: string) => {
    const newParams = new URLSearchParams(history.location.search);
    newParams.set(key, value);
    history.replace({ search: newParams.toString() });
  };

  const getNumericParam = (
    key: string,
    {
      min,
      max,
      defaultValue,
    }: { min: number; max: number; defaultValue: number },
  ): number => {
    const raw = searchParams.get(key);
    const parsed = raw !== null ? parseInt(raw, 10) : NaN;
    return !isNaN(parsed) && parsed >= min && parsed <= max
      ? parsed
      : defaultValue;
  };

  return { searchParams, setSearchParam, getNumericParam };
};

export default useSearchParams;
